import { Button, CloseButton, Divider, Flex, LoadingOverlay, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { yupResolver } from "mantine-form-yup-resolver";
import React from "react";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { OrderApi } from "../../apis";
import HttpHandler from "../../utils/http-handler";
import { message } from "../../utils/message";
import { PageLayout } from "../layout";

const schema = yup.object();

export type IFormData = {
  buyerBusinessId: string;
};

export function SupplierSalesSplitForm({
  isDropshipping,
  onCancel,
  id,
  onSuccess,
}: {
  isDropshipping: any;
  onCancel: () => void;
  id: string;
  onSuccess: () => void;
}) {
  const { t } = useTranslation(["supplierSales", "common"]);
  const [loading, setLoading] = React.useState<boolean>(false);

  const form = useForm({
    mode: "controlled",
    initialValues: {},
    validate: yupResolver(schema),
  });

  const onSubmit = async () => {
    const { hasErrors } = form.validate();
    if (hasErrors) return;
    setLoading(true);

    try {
      await OrderApi.split(
        id,
        (isDropshipping[1] || [])?.map((item: any) => ({
          id: item?.id,
        })),
      );

      message.success(t("common:messages.requestSuccess"));
      onSuccess();
    } catch (err) {
      message.error((err as HttpHandler)?.message!);
    }
    setLoading(false);
  };

  return (
    <PageLayout
      title={t("supplierSales:sales.splitOrder")}
      extra={[
        <CloseButton
          onClick={() => {
            onCancel && onCancel();
          }}
          key={1}></CloseButton>,
      ]}>
      <LoadingOverlay visible={loading} />
      <Divider color="gray" mb="xs" />
      <Text
        size="sm"
        fw={500}
        c="var(--mantine-color-dark-5)"
        style={{
          textAlign: "justify",
          letterSpacing: "1px",
          textIndent: "20px",
        }}>
        {t("supplierSales:sales.splitConfirmPrefix")} <> </>
        {(isDropshipping[1] || []).some((item: any) => !item.isDropshipping) && (
          <>
            SKU: <> </>
            {(isDropshipping[1] || [])
              .filter((item: any) => !item.isDropshipping)
              .map((item: any, index: number) => (
                <span key={index}>{item?.skuCode} </span>
              ))}
            {t("supplierSales:sales.splitConfirmSuffix")} <> </>
          </>
        )}
      </Text>
      <Divider color="gray" my="xs" />
      <Flex direction="row" justify="space-between" mt={20}>
        <Button variant="outline" onClick={() => onCancel && onCancel()}>
          {t("common:actions.cancel")}
        </Button>
        <Button variant="filled" onClick={onSubmit}>
          {t("supplierSales:sales.splitOrder")}
        </Button>
      </Flex>
    </PageLayout>
  );
}
